import { render, staticRenderFns } from "./DynamicTableCell.vue?vue&type=template&id=815edf2a&scoped=true"
import script from "./DynamicTableCell.vue?vue&type=script&lang=js"
export * from "./DynamicTableCell.vue?vue&type=script&lang=js"
import style0 from "./DynamicTableCell.vue?vue&type=style&index=0&id=815edf2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815edf2a",
  null
  
)

export default component.exports